<template>
  <v-btn
    depressed
    small
    height="32"
    class="btn-white w-100 btn-back btn_medium w-100 mr-1"
    @click="$router.go(-1)"
  >
    Cancel
  </v-btn>
</template>
<script>
export default {};
</script>
